import { Component, OnInit, ElementRef } from '@angular/core';
import { DialogService } from "../dialog/index";
import { DialogComponent } from "../dialog/dialog.component";
import { ISalesContacts, Sales_contact__Model } from '../../interface/Backofficesale_Master'
import { InSalesService } from '../../../shared/services/inventory/in-sales.service'
export interface ContactSearchModel {
  title: string;
  data: any;
}
@Component({
  selector: 'app-contact-search',
  templateUrl: './contact-search.component.html',
  styleUrls: ['./contact-search.component.css']
})
export class ContactSearchComponent extends DialogComponent<ContactSearchModel, boolean> implements ContactSearchModel, OnInit {
  title: string;
  data: any = []
  fullData: any;
  salesContact: ISalesContacts
  result: any = { item: [], result: false };
  rtnData: any;
  selectedRow: number = -1;
  sliceStrat: number = 0;
  sliceEnd: number = 15;
  Unit: string = "";
  loading: boolean = false;
  f: any = {
    PhoneNo: "",
    Name: "",
    Email: "",
    Nationality: ""
  };
  private el: ElementRef;
  constructor(dialogService: DialogService, private sa: InSalesService) { super(dialogService); }

  ngOnInit() {
    this.fullData = this.data;
    if (!this.fullData) {
      this.close();
    } else {
      this.loading = true;
    }
    // this.salesContact = this.data
    // this.fullData = this.data;
  }
  confirm(item) {
    this.result = { item: item, result: true };
    this.close();
  }
  setClickedRow(e) {
    this.selectedRow = e;
    document.getElementById("focus").focus();
  }
  NextBut() {
    if (!this.NexbutEnable()) {
      this.fullData = this.data;
      this.sliceEnd = Number(this.sliceEnd) + 15
      this.selectedRow = 0
    }
  }
  PreBut() {
    if (!this.PrebutEnable()) {
      this.fullData = this.data;
      this.sliceEnd = Number(this.sliceEnd) - 15
      this.selectedRow = 0
    }
  }
  NexbutEnable(): boolean {
    return this.fullData.data.legth > this.sliceEnd
  }
  PrebutEnable(): boolean {
    return this.sliceEnd < 16
  }
  ItesmSearch(e, type) {
    if (e.keyCode == 13 && e.which == 13) {
      this.fullData = this.data;
      switch (type) {
        case "PhoneNo":
          this.f.PhoneNo = e.target.value;
          break;
        case "Name":
          this.f.Name = e.target.value;
          break;
        case "Email":
          this.f.Email = e.target.value;
          break;
        case "Nationality":
          this.f.Nationality = e.target.value;
          break;
      }
      this.selectedRow = 0;
    } else if (e.keyCode == 40 && e.which == 40) {
      document.getElementById("focus").focus();
      this.selectedRow = 0;
    }
  }
  scroll(event: KeyboardEvent) {
    //up 38 down 40
    event.preventDefault();
    if (event.keyCode === 40) {
      if (this.selectedRow > 13) {
        this.NextBut();
      } else {
        this.selectedRow++;
      }
    } else if (event.keyCode === 38) {
      if (this.selectedRow < 1) {
        this.PreBut();
      } else {
        this.selectedRow--;
      }
    } else if (event.keyCode === 13) {
      this.selecedItem();
    }
    else return;
  }
  selecedItem() {
    var abc = document.getElementsByClassName("selectedItesmsaerch786")[0].getElementsByClassName("bkd")[0].innerHTML;
    var bcd = this.fullData.find(x => x.PhoneNo == abc);
    this.confirm(bcd);
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/iPOSERP/src/app/shared/component/contact-search/contact-search.component.ts